// Trabajar en centavos evita residuos que terminan seleccionando otra factura.
export function distribuirPorAntiguedad(facturas, monto) {
  let restante = Math.round(Number(monto) * 100);
  const candidatas = facturas
    .filter(f => ['F', 'SI'].includes(String(f.tipoDocumento).toUpperCase()))
    .map(f => ({ ...f, centavos: Math.round(Number(f.saldo) * 100) }))
    .filter(f => f.centavos > 0)
    .sort((a, b) => String(a.fecha).slice(0, 10).localeCompare(String(b.fecha).slice(0, 10)) || Number(a.id) - Number(b.id));
  const seleccionados = {};
  for (const f of candidatas) {
    if (restante <= 0) break;
    const usar = Math.min(restante, f.centavos);
    seleccionados[f.id] = (usar / 100).toFixed(2);
    restante -= usar;
  }
  return {
    seleccionados,
    aplicado: (Math.round(Number(monto) * 100) - restante) / 100,
    restante: restante / 100,
    totalPendiente: candidatas.reduce((s, f) => s + f.centavos, 0) / 100
  };
}
